<template>
  <div class="companyBox">
    <navigation></navigation>
    <div class="homeBG"></div>
    
    <div class="navBox">
      <div class="text_nav1">
        <div class="navMap">
          网站地图
        </div>
      </div>
      <div class="navContent">
        <div style="width: 100%; height: 80px;">
          <img src="../img/wzbj.png" alt="">
        </div>
        <div class="mapList">
          <div class="mapListBox">
            <div style="font-size: 25px; margin-bottom: 20px; font-weight: 700; color: #5d5d5e;">
              <router-link style="color: #5d5d5e; text-decoration: none;" to="/">首页</router-link>
            </div>
          </div>
          <div class="mapListBox">
            <div style="font-size: 25px; margin-bottom: 20px; font-weight: 700; color: #5d5d5e;">
              <router-link style="color: #5d5d5e; text-decoration: none;" to="/companyProfile">公司简介</router-link>
            </div>
          </div>
          <div class="mapListBox">
            <div style="font-size: 25px; margin-bottom: 20px; font-weight: 700; color: #5d5d5e;">
              <router-link style="color: #5d5d5e; text-decoration: none;" to="/qualificationHonor">资质荣誉</router-link>
            </div>
          </div>
          <div class="mapListBox">
            <div style="font-size: 25px; margin-bottom: 20px; font-weight: 700; color: #5d5d5e;">
              产品展示
            </div>
            <div class="mapListSize">
              <router-link style="color: #5d5d5e; text-decoration: none;" to="/lvtong">环保滤筒</router-link>
            </div>
            <div class="mapListSize">
              <router-link style="color: #5d5d5e; text-decoration: none;" to="/lvdai">环保滤袋</router-link>
            </div>
          </div>
          <div class="mapListBox">
            <div style="font-size: 25px; margin-bottom: 20px; font-weight: 700; color: #5d5d5e;">
              <router-link style="color: #5d5d5e; text-decoration: none;" to="/humanResources">人力资源</router-link>
            </div>
          </div>
          <div class="mapListBox">
            <div style="font-size: 25px; margin-bottom: 20px; font-weight: 700; color: #5d5d5e;">
              <router-link style="color: #5d5d5e; text-decoration: none;" to="/contactUs">联系我们</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <dibu></dibu>
  </div>
</template>

<script>
import navigation from '@/views/navigation.vue'
import dibu from './dibu.vue';

export default {
  name: 'CompanyProfile',
  components: {
    navigation,
    dibu,
  }
}
</script>

<style lang="scss" scoped>
.companyBox {
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
  position: relative;
  
  .homeBG {
    width: 100%;
    height: 800px;
    background-image: url('../img/wzdh.png');
    background-size: 100% 100%;
  }
  
  .navBox {
    width: 100%;
    height: 800px;
    padding-bottom: 130px;
    box-sizing: border-box;
  }

  .text_nav1 {
    width: 100%;
    height: 100px;
  }

  .navMap {
    width: 200px;
    height: 100%;
    margin: auto;
    text-align: center;
    font-size: 26px;
    line-height: 100px;
    font-weight: 700;
  }

  .navBox .navContent {
    width: 1400px;
    height: 100%;
    margin: auto;
  }

  .navContent img {
    width: 100%;
    height: 100%;
  }

  .mapList {
    display: flex;
    width: 100%;
    height: 400px;
    text-align: center;
    border-top: 1px solid #ccc;
  }

  .mapListBox {
    flex: 1;
    padding: 30px;
    border-right: 1px solid #ccc;
    box-sizing: border-box;
  }

  .mapListSize {
    font-size: 20px;
    margin-bottom: 15px;
    color: #5d5d5e;
  }
}

/* 平板适配 (769px - 1024px) */
@media screen and (min-width: 769px) and (max-width: 1024px) {
  .companyBox {
    .homeBG {
      height: 500px;
      background-size: cover;
      background-position: center;
    }
    
    .navBox {
      height: auto;
      padding-bottom: 80px;
    }

    .navContent {
      width: 95% !important;
      max-width: 900px;
      padding: 0 20px;
      box-sizing: border-box;
    }

    .navContent > div:first-child {
      height: 60px !important;
      margin-bottom: 30px;
    }

    .mapList {
      height: auto;
      min-height: 350px;
    }

    .mapListBox {
      padding: 20px 15px;
    }

    .mapListBox > div:first-child {
      font-size: 22px !important;
      margin-bottom: 15px;
    }

    .mapListSize {
      font-size: 18px !important;
      margin-bottom: 12px;
    }
  }
}

/* 小平板适配 (481px - 768px) */
@media screen and (min-width: 481px) and (max-width: 768px) {
  .companyBox {
    .homeBG {
      height: 400px;
      background-size: cover;
      background-position: center;
    }
    
    .navBox {
      height: auto;
      padding-bottom: 60px;
    }

    .navContent {
      width: 100% !important;
      padding: 0 20px;
      box-sizing: border-box;
    }

    .navContent > div:first-child {
      height: 50px !important;
      margin-bottom: 25px;
    }

    .mapList {
      flex-wrap: wrap;
      height: auto;
      border-top: none;
      justify-content: flex-start;
    }

    .mapListBox {
      flex: 1 1 45%;
      min-width: 200px;
      border-right: 1px solid #ccc;
      border-bottom: 1px solid #ccc;
      padding: 25px 15px;
      margin: 0 5px 10px 0;
      text-align: left;
    }

    .mapListBox:nth-child(2n) {
      border-right: none;
    }

    .mapListBox > div:first-child {
      font-size: 21px !important;
      margin-bottom: 15px;
      text-align: left;
    }

    .mapListSize {
      font-size: 17px !important;
      margin-bottom: 10px;
      text-align: left;
    }
  }
}

/* 手机端适配 (最大480px) */
@media screen and (max-width: 480px) {
  .companyBox {
    .homeBG {
      height: 300px;
    }
    
    .navMap {
      width: 150px;
      font-size: 22px;
      line-height: 80px;
    }

    .text_nav1 {
      height: 80px;
    }

    .navContent {
      padding: 0 15px;
    }

    .navContent > div:first-child {
      height: 40px !important;
      margin-bottom: 20px;
    }

    .mapList {
      flex-direction: column;
      height: auto;
      border-top: none;
      text-align: left;
    }

    .mapListBox {
      flex: none;
      border-right: none;
      border-bottom: 1px solid #ccc;
      padding: 20px 15px;
      margin: 0;
      text-align: left;
    }

    .mapListBox:last-child {
      border-bottom: none;
    }

    .mapListBox > div:first-child {
      font-size: 20px !important;
      margin-bottom: 15px;
      text-align: left;
      color: #5d5d5e !important;
    }

    .mapListSize {
      font-size: 16px !important;
      margin-bottom: 10px;
      text-align: left;
      color: #5d5d5e !important;
    }
  }
}
</style>